var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogoBr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 115"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 11",
    d: "M32.446 0a32.446 32.446 0 1 0 32.445 32.445A32.482 32.482 0 0 0 32.446 0m0 61.733a29.287 29.287 0 1 1 29.288-29.288 29.288 29.288 0 0 1-29.288 29.288",
    transform: "translate(.055 .055)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 12",
    d: "M76.526 47.28a29.238 29.238 0 1 1-29.24-29.237 29.239 29.239 0 0 1 29.24 29.237",
    transform: "translate(-14.786 -14.781)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "M42.363 72.655a30.3 30.3 0 1 1 30.3-30.3 30.337 30.337 0 0 1-30.3 30.3m0-58.511a28.21 28.21 0 1 0 28.21 28.209 28.241 28.241 0 0 0-28.21-28.209",
    transform: "translate(-9.863 -9.853)",
    style: {
      fill: "#d91579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "m205.57 66.741-5.57-.385-.457 24.6 3.391.315z",
    transform: "translate(-164.609 -54.795)",
    style: {
      fill: "#d91579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "m88.551 73.183-6.28 1.085 4.619 22.173 2.572-.123z",
    transform: "translate(-67.842 -60.426)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M122.085 67.364s8.491-1 10.832 4.577-3.549 7.8-3.549 7.8 6.356 1.216 4.513 6.936-10.77 5.137-10.77 5.137l.061-1.958s4.829.478 5.586-3.452c.781-4.057-4.99-4.089-4.99-4.089l-.189-2.928s4.343-.178 4.5-3.666-5.634-3.053-5.634-3.053z",
    transform: "translate(-100.734 -55.568)",
    style: {
      fill: "#d91579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 17",
    d: "M229.664 73.326s8.53.029 9.117 6.533c.589 6.533-6.345 8.634-6.345 8.634l2.964 7.587-2.676.514-4.635-7.222.348-2.757s4-.882 4.6-3.279c.958-3.865-3.831-4.609-3.831-4.609z",
    transform: "translate(-188.227 -60.544)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18",
    d: "M99.468 217.689a2.891 2.891 0 0 1 1.325-.505 2.841 2.841 0 0 1 3.252 2.326 2.806 2.806 0 0 1-2.537 3.066 2.949 2.949 0 0 1-1.413-.159l.083.527-1.524.194-.987-7.452 1.524-.19zm1.513.909a1.35 1.35 0 0 0-1.2 1.45 1.37 1.37 0 0 0 1.539 1.106 1.356 1.356 0 0 0 1.2-1.452 1.381 1.381 0 0 0-1.539-1.1",
    transform: "translate(-80.544 -177.794)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 19",
    d: "m140.239 227.65 1.536.074-.436 5.839-1.535-.072.067-.535a2.9 2.9 0 0 1-1.4.268 2.769 2.769 0 0 1-2.734-2.858 2.864 2.864 0 0 1 3.074-2.573 2.908 2.908 0 0 1 1.359.4zm-2.975 2.791a1.344 1.344 0 0 0 1.3 1.353 1.388 1.388 0 0 0 1.459-1.222 1.34 1.34 0 0 0-1.3-1.353 1.4 1.4 0 0 0-1.458 1.222",
    transform: "translate(-111.956 -187.805)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 20",
    d: "M176.025 222.118c-.1.023-.129.027-.229.055-.737.18-1.182.738-.972 1.2l.97 2.131c.461 1.015-.459 2.15-2.057 2.537l-.225.055-.442-.968.228-.055c.739-.18 1.186-.734.973-1.2l-.969-2.129c-.459-1.015.464-2.146 2.059-2.531.1-.023.129-.03.227-.055z",
    transform: "translate(-142.741 -182.458)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 21",
    d: "m195.049 216.325-3 2.719.5-8.152 1.533.1-.333 4.53 2.69-2.738 1.109.975-1.446 1.484 1.691 2.285-1.236.835z",
    transform: "translate(-158.428 -174.001)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 22",
    d: "M229.3 216.438a.922.922 0 0 1-1.839.061.877.877 0 0 1 .887-.888.891.891 0 0 1 .952.827m-.11 1.294.175 5-1.534.051-.178-5z",
    transform: "translate(-187.603 -177.884)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 23",
    d: "m249.175 223.11-.344 6.063-3.553-3.805-.066 2.7-1.536-.021.286-6 3.608 3.738.066-2.7z",
    transform: "translate(-201.026 -183.196)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 24",
    d: "m99.885 265.412 1.7-.129.076.639a3.143 3.143 0 0 1 1.5-.486l.174-.013.132 1.579-.172.013a1.494 1.494 0 0 0-1.41 1.539l.236 3.076-1.7.127z",
    transform: "translate(-82.361 -218.868)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 25",
    d: "M120.774 272.787a2.443 2.443 0 1 1-2.579 2.465 2.53 2.53 0 0 1 2.579-2.465m.041 3.59a1.158 1.158 0 1 0-1.251-1.142 1.221 1.221 0 0 0 1.251 1.142",
    transform: "translate(-97.478 -225.039)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 26",
    d: "M151.587 267.365a2.6 2.6 0 0 1 1.247-.271 2.511 2.511 0 0 1 2.546 2.495 2.549 2.549 0 0 1-2.687 2.378 2.619 2.619 0 0 1-1.231-.33l-.023.45-1.379-.032.194-6.738 1.38.03zm1.21 1a1.237 1.237 0 0 0-1.272 1.129 1.21 1.21 0 0 0 1.2 1.184 1.16 1.16 0 1 0 .067-2.313",
    transform: "translate(-123.773 -218.901)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 27",
    d: "M183.205 261.172a2.644 2.644 0 0 1 3.934 2 2.524 2.524 0 0 1-2.525 2.529 2.616 2.616 0 0 1-1.253-.258l.025.45-1.378.046-.25-6.738 1.379-.044zm1.276.932a1.159 1.159 0 1 0 1.28 1.112 1.239 1.239 0 0 0-1.28-1.112",
    transform: "translate(-149.93 -213.817)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 28",
    d: "M216.195 259.251a.815.815 0 0 1-.87.729.788.788 0 0 1-.779-.81.827.827 0 0 1 1.649.08m-.206 1.144-.253 4.488-1.377-.068.253-4.484z",
    transform: "translate(-176.797 -213.219)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 29",
    d: "m233.972 261.844-.15 5.6-3.308-3.586-.017 2.419-1.377-.021.04-5.949 3.417 3.93.019-2.418z",
    transform: "translate(-189.006 -214.774)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30",
    d: "m262.111 265.967-.226.042c-.725.135-1.162.683-.959 1.173l.946 2.247c.45 1.072-.46 2.182-2.031 2.48l-.222.04-.431-1.023c.1-.015.125-.023.226-.042.727-.135 1.168-.676.958-1.171l-.944-2.249c-.448-1.07.463-2.171 2.032-2.471l.223-.042z",
    transform: "translate(-213.794 -218.6)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 31",
    d: "M279.387 263.464s.449-.383-.022-.493a.8.8 0 0 0-.164-.019h-.151v.848h.169v-.3l.23.3h.178zm-.17-.084v-.288s.437.034 0 .288",
    transform: "translate(-230.154 -216.876)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 32",
    d: "M276.862 262.58a.754.754 0 1 1 .751-.753.755.755 0 0 1-.751.753m0-1.34a.586.586 0 1 0 .581.588.588.588 0 0 0-.581-.588",
    transform: "translate(-227.736 -215.334)",
    style: {
      fill: "#004295"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 17",
    style: {
      fill: "none"
    },
    d: "M0 0h65v65H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoBr);
export default __webpack_public_path__ + "static/media/ic-logo-br.7eda5c87ab071ac9898b860db8adfea6.svg";
export { ForwardRef as ReactComponent };